import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";

// Durées typiques mesurées en production (31/10 : brief 29 s, visuels 83 s, contrôle et régénération 140 s).
const STEPS = [
  { key: "brief", label: "Rédaction du brief", s: 35 },
  { key: "visuels", label: "Création des visuels", s: 90 },
  { key: "controle", label: "Contrôle des textes", s: 140 },
  { key: "finalisation", label: "Finalisation", s: 25 },
];

export function remainingSeconds(stageKey, stageAt, now = Date.now()) {
  const idx = Math.max(0, STEPS.findIndex((x) => x.key === stageKey));
  const inStage = stageAt ? Math.max(0, (now - new Date(stageAt).getTime()) / 1000) : 0;
  const current = Math.max(0, STEPS[idx].s - inStage);
  return current + STEPS.slice(idx + 1).reduce((a, x) => a + x.s, 0);
}

const remainingLabel = (sec) => {
  if (sec <= 20) return "Encore quelques instants";
  if (sec < 60) return "Moins d'une minute restante";
  const m = Math.ceil(sec / 60);
  return `Environ ${m} minute${m > 1 ? "s" : ""} restante${m > 1 ? "s" : ""}`;
};

export const ImageProgress = ({ job, testid }) => {
  const [, setNow] = useState(0);
  useEffect(() => { const id = setInterval(() => setNow((x) => x + 1), 1000); return () => clearInterval(id); }, []);
  const key = job?.stage_key || "brief";
  const idx = Math.max(0, STEPS.findIndex((x) => x.key === key));
  return (
    <div className="px-6 pb-4" data-testid={testid}>
      <ol className="flex flex-wrap gap-x-5 gap-y-1 text-xs mb-2">
        {STEPS.map((st, k) => (
          <li key={st.key} data-testid={`${testid}-step-${st.key}`}
            className={`inline-flex items-center gap-1.5 ${k < idx ? "text-emerald-700" : k === idx ? "text-slate-900 font-semibold" : "text-slate-400"}`}>
            {k < idx ? <Check className="h-3.5 w-3.5" /> : k === idx ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />}
            {st.label}
          </li>
        ))}
      </ol>
      <p className="text-xs text-slate-500" data-testid={`${testid}-remaining`}>
        {remainingLabel(remainingSeconds(key, job?.stage_at))} (une génération prend en général 4 à 6 minutes).
        {" "}Vous pouvez fermer cette page : vos visuels vous attendront en haut de « Créer un post ».
      </p>
    </div>
  );
};

export default ImageProgress;
